import { motion } from "framer-motion";
import { Calculator } from "lucide-react";
import { estimateSubsidy } from "../lib/aca";

const usd = (v) => `$${Math.round(v).toLocaleString()}`;

const message = (e) => {
  if (e.status === "medicaid") return ["You may qualify for Medicaid", "Income below 100% of the poverty level usually doesn't qualify for marketplace tax credits, but Medicaid may be available in your state. I'll check for you."];
  if (e.status === "over") return ["Above the subsidy limit", "Households above 400% of the poverty level don't qualify for tax credits in 2027. Private and off-exchange plans may be a better value, and I'll compare them."];
  const head = `You'd pay no more than ~${usd(e.monthly)}/mo`;
  const tail = e.status === "maybe-medicaid" ? " In states that expanded Medicaid, you may qualify for Medicaid instead." : "";
  return [head, `For the benchmark Silver plan, about ${e.rate.toFixed(2)}% of income. A tax credit covers the rest of its price, and you can use it toward any metal level.${tail}`];
};

export const SubsidyEstimate = ({ income, size, zip }) => {
  const e = estimateSubsidy({ income, size, zip });
  if (!e) return null;
  const [head, body] = message(e);
  return (
    <motion.div initial={{ opacity: 0.4, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}
      className="sm:col-span-2 rounded-2xl bg-[#0B281E] text-[#FAF8F5] p-5 sm:p-6 grid sm:grid-cols-[auto_1fr] gap-5 items-center" data-testid="subsidy-estimate">
      <div className="flex sm:flex-col items-center sm:items-start gap-3 sm:gap-1 sm:pr-6 sm:border-r border-white/15">
        <Calculator className="w-5 h-5 text-[#E5A855]" />
        <p className="font-serif-d text-4xl leading-none" data-testid="subsidy-fpl-pct">{Math.round(e.pct)}%</p>
        <p className="font-mono-d text-[10px] uppercase tracking-[0.18em] text-[#F4F1EA]/75">of poverty level</p>
      </div>
      <div>
        <p className="font-semibold text-[#E5A855]" data-testid="subsidy-headline">{head}</p>
        <p className="text-sm text-[#F4F1EA]/80 mt-1 leading-relaxed">{body}</p>
        <p className="text-[11px] text-[#F4F1EA]/60 mt-3">Estimate for 2027 coverage · household of {size} · 2026 federal poverty guidelines. Not a guarantee — final amounts depend on your application.</p>
      </div>
    </motion.div>
  );
};
